<template>
    <center-box title="Nastavení">
        <div v-if="isPlannedMaintenance != null">
            <div class="mb-4 bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Plánovaná odstvávka ISDS
                </h3>
                <p class="mt-1 text-sm text-gray-500">
                    Právě probíhá plánovaná odstávka systému datových schránek.
                    <br>
                    Můžete dále procházet obsah své schránky, ale nebude možné přijímat a odesílat nové zprávy.
                </p>
                <p class="mt-1 text-sm text-gray-500">
                    Plánovaný konec odstávky je {{ (new Date(isPlannedMaintenance.end)).toLocaleDateString() + ', ' + (new Date(isPlannedMaintenance.end)).toLocaleTimeString() }}
                </p>
            </div>

            <div class="text-right">
                <secondary-button @click.native="ignore" type="button">
                    Pokračovat
                </secondary-button>
            </div>
        </div>

        <form v-else @submit.prevent="submit" autocomplete="off">
            <div class="mb-4 bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Problém s účtem ISDS
                </h3>
                <p class="mt-1 text-sm text-gray-500">
                    Při kontrole připojení k vašemu účtu došlo k chybě. {{ error }}
                    <br>V případě problémů kontaktujte prosím podporu.
                    <br>Tuto chybu se můžete rozhodnout ignorovat a používat dále svou DSchránku. Nedojde ale k připojení do systému ISDS.
                </p>
            </div>


            <jet-validation-errors class="mb-4" />

            <div class="mb-4">
                <label for="username" class=" block text-sm font-medium text-gray-700">Uživatelské jméno</label>
                <div class="mt-1">
                    <input disabled v-model="user.username" type="text" name="username" id="username" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="sedmimístný kód">
                </div>
            </div>

            <div class="mb-4">
                <label for="password" class="block text-sm font-medium text-gray-700">Heslo</label>
                <div class="mt-1">
                    <input v-model="user.password" type="password" name="password" id="password" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="heslo">
                </div>
            </div>

            <div class="text-right">
                <secondary-button @click.native="ignore" type="button">
                    Ignorovat
                </secondary-button>
                <primary-button @click.native="testUpdate" type="button" class="ml-2">
                    Vyzkoušet s novými údaji
                </primary-button>
            </div>

        </form>

    </center-box>

</template>
<script>
import CenterBox from "@/Layouts/CenterBox";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import PrimaryButton from "@/Jetstream/Button";
import ValidationErrors from "@/Jetstream/ValidationErrors";
export default {
    name: "ProgressISDSError",
    components: {
        'jet-validation-errors': ValidationErrors,
        CenterBox,
        SecondaryButton,
        PrimaryButton
    },
    data() {
        return {
            originalUser: this.$page.props.user,
            user: this.$page.props.user,
            isPlannedMaintenance: this.$page.props.isPlannedMaintenance,
            error: this.$page.props.error,
        }
    },
    methods: {
        testUpdate(){
            this.$inertia.post(route('settings.progress.user.save', {
                referer: 'ISDSError',
                originalUsername: this.originalUser.username,
                username: this.user.username,
                password: this.user.password,
                method: this.user.method
            }));
        },
        ignore(){
            this.$inertia.visit(route('app'));
        }
    }
}
</script>

<style scoped>

</style>
